<template>
  <div class="admin_send_request_modal">
    <UeModal
      name="admin_send_request_modal"
      width="50%"
      title="Edit Send Request"
      @before-open="beforeOpen"
    >
      <div class="modal_body" v-if="send_request">
        <div class="alert alert-danger mb-3" v-if="showWaitWarning">
          Please hold, saving the send request can take a minute or more depending on the list size.
        </div>
        <div class="alert alert-danger" v-if="error">
          {{ error }}
        </div>

        <TextInput v-model="send_request.subject" label="Email Subject" />

        <div class="form-group">
          <label for="send-request-email-text">Text:</label>
          <textarea
            v-model="send_request.email_text"
            id="send-request-email-text"
            class="form-control"
            rows="10"
          ></textarea>
        </div>

        <div class="when">
          <label>When:</label>
          <div class="row">
            <div class="col">
              <input
                type="date"
                class="form-control"
                v-model="date"
                :min="new Date().toISOString().split('T')[0]"
              />
            </div>
            <div class="col">
              <input type="time" class="form-control" v-model="time" />
            </div>
          </div>
        </div>

        <button class="btn btn-primary mt-3" @click="saveSendRequest()" :disabled="disable">
          Save
        </button>
      </div>
    </UeModal>
  </div>
</template>

<script lang="ts">
import axios from '@lib/apiClient'
import TextInput from '@/app/components/TextInput.vue'

export default {
  components: { TextInput },
  data() {
    return {
      send_request: null,
      error: null,
      showWaitWarning: false,
      disable: false,
      date: null,
      time: null,
      warningTimer: null,
    }
  },
  emit: ['saved'],
  methods: {
    clearState() {
      this.error = null
      this.showWaitWarning = false
      this.disable = false
      if (this.warningTimer) clearTimeout(this.warningTimer)
    },
    saveSendRequest() {
      this.clearState()
      this.disable = true

      // Show warning after 3 seconds if request is still processing.
      this.warningTimer = setTimeout(() => {
        this.showWaitWarning = this.disable
      }, 3000)

      this.send_request.requested_at = new Date(`${this.date} ${this.time}`).toISOString()
      if (!this.send_request.subject) this.error = 'Choose a Subject'
      if (this.error) {
        this.disable = false
        return
      }

      var url,
        method = ''
      if (this.send_request.id) {
        url = `/admin/api/send_requests/${this.send_request.id}.json`
        method = 'patch'
      } else {
        url = `/admin/api/send_requests.json`
        method = 'post'
      }

      axios({
        url: url,
        method: method,
        data: {
          send_request: this.send_request,
        },
      })
        .then(() => {
          this.$toast('Send Request Saved')
          this.$closeModal('admin_send_request_modal')
          this.disable = false
        })
        .catch(() => {
          this.clearState()
          this.error = 'Something went wrong.'
        })
    },
    beforeOpen(e) {
      this.send_request = e.params
      if (this.warningTimer) clearTimeout(this.warningTimer)

      if (this.send_request.requested_at) {
        const requested_at = new Date(this.send_request.requested_at)
        const date = requested_at.toISOString().split('T')[0]
        const time = requested_at.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })
        this.date = date
        this.time = time
      }
    },
  },
  beforeDestroy() {
    if (this.warningTimer) clearTimeout(this.warningTimer)
  },
}
</script>

<style lang="sass" scoped>
.alert-danger
  background: red
  padding: 20px
  border-radius: 10px
  color: white
</style>
